import { ScheduleLabels } from "@mantine/schedule"
import { useTranslation } from "react-i18next"

export function useGetScheduleLabels() {
  const { t } = useTranslation("app_server")
  const labels = React.useMemo<ScheduleLabels>(
    () => ({
      day: t("MantineSchedule_day"),
      week: t("MantineSchedule_week"),
      month: t("MantineSchedule_month"),
      year: t("MantineSchedule_year"),
      allDay: t("MantineSchedule_allDay"),
      weekday: t("MantineSchedule_weekday"),
      timeSlot: t("MantineSchedule_timeSlot"),
      today: t("MantineSchedule_today"),
      next: t("MantineSchedule_next"),
      previous: t("MantineSchedule_previous"),
      more: t("MantineSchedule_more"),
      selectMonth: t("MantineSchedule_selectMonth"),
      selectYear: t("MantineSchedule_selectYear"),
      switchToDayView: t("MantineSchedule_switchToDayView"),
      switchToWeekView: t("MantineSchedule_switchToWeekView"),
      switchToMonthView: t("MantineSchedule_switchToMonthView"),
      switchToYearView: t("MantineSchedule_switchToYearView"),
      viewSelectLabel: t("MantineSchedule_viewSelectLabel"),
      noEvents: t("MantineSchedule_noEvents"),
      moreLabel: (hiddenEventsCount: number) =>
        t("MantineSchedule_moreLabel", { count: hiddenEventsCount }),
      resource: t("MantineSchedule_resource"),
      resources: t("MantineSchedule_resources"),
      resourceSlot: t("MantineSchedule_resourceSlot"),
      agenda: t("MantineSchedule_agenda"),
    }),
    [t]
  )
  return labels
}
